import { SET_MEMO_ASSETS } from "./memoAssetsActions";

export const memoAssets = (state = { assets: [] }, action) => {
    switch (action.type) {
        case SET_MEMO_ASSETS:
            return { ...state, assets: action.memoAssets };

        default:
            return state;
    }
};
